// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconStoresPlusPath = 'm15 2.5 3.466 8.493c.1.246.295.44.541.541L27.5 15l-8.493 3.466a.988.988 0 0 0-.541.541L15 27.5l-3.466-8.493a.988.988 0 0 0-.541-.541L2.5 15l8.493-3.466a.988.988 0 0 0 .541-.541L15 2.5Zm1.636 9.24L15 7.73l-1.636 4.01a2.965 2.965 0 0 1-1.625 1.624L7.731 15l4.008 1.636a2.966 2.966 0 0 1 1.544 1.444l.082.181L15 22.268l1.636-4.008a2.966 2.966 0 0 1 1.443-1.543l.181-.081L22.268 15l-4.008-1.636a2.966 2.966 0 0 1-1.543-1.443l-.081-.181Zm9.506-4.169-2.227-.909a.793.793 0 0 1-.435-.435L22.571 4l-.909 2.227a.793.793 0 0 1-.434.435L19 7.572l2.227.908c.198.08.355.237.435.435l.91 2.227.908-2.227a.793.793 0 0 1 .435-.435l2.227-.909Z';
var NavigationIconStoresPlus = baseIcon('NavigationIconStoresPlus', {
  getPath: () => NavigationIconStoresPlusPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconStoresPlus;
//# sourceMappingURL=index.js.map